import { useLocation, useNavigate } from 'react-router';

import { ROUTES } from '~shared/config/routes';
import { useIsDesktop } from '~shared/lib/responsive';
import { MobileSelect } from '~shared/ui/mobile-select';

import { Chips } from '@breezeventures/ui-kit/chips';

type TransactionsTab = 'loans' | 'payments';

type Props = {
  showPayments: boolean;
};

export const TransactionsTabs = ({ showPayments }: Props) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isDesktop = useIsDesktop();

  const activeTab: TransactionsTab = pathname.startsWith(
    ROUTES.transactions.payments
  )
    ? 'payments'
    : 'loans';

  const handleChange = (value: string) => {
    navigate(
      value === 'payments'
        ? ROUTES.transactions.payments
        : ROUTES.transactions.loans
    );
  };

  if (!isDesktop) {
    const options: { value: TransactionsTab; label: string }[] = [
      { value: 'loans', label: 'Signed loans' },
      ...(showPayments
        ? [{ value: 'payments' as const, label: 'Payments' }]
        : []),
    ];

    return (
      <MobileSelect
        options={options}
        value={activeTab}
        onChange={handleChange}
      />
    );
  }

  return (
    <Chips
      type="single"
      variant="soft"
      size="m"
      value={activeTab}
      onChange={handleChange}
    >
      <Chips.Item value="loans">Signed loans</Chips.Item>
      {showPayments && <Chips.Item value="payments">Payments</Chips.Item>}
    </Chips>
  );
};
